import * as Types from '../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type UndoMarketingOptOutMutationVariables = Types.Exact<{
  undoToken: Types.Scalars['String']
}>

export type UndoMarketingOptOutMutation = {
  undoMarketingOptOut: { __typename: 'MarketingOptInResult'; success: boolean }
}

export const UndoMarketingOptOutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UndoMarketingOptOut' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'undoToken' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'undoMarketingOptOut' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'undoToken' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'undoToken' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UndoMarketingOptOutMutation,
  UndoMarketingOptOutMutationVariables
>
